import { hotTags, stats } from "@/mocks/chigua";

export default function Hero() {
  return (
    <section id="hero" className="relative w-full overflow-hidden">
      {/* background image */}
      <div className="absolute inset-0 -z-10">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20editorial%20collage%20background%20of%20floating%20news%20newspaper%20headlines%2C%20popcorn%20and%20watermelon%20slices%20drawn%20in%20flat%20illustration%2C%20terracotta%20orange%20and%20cream%20and%20gold%20tones%2C%20scattered%20text%20fragments%2C%20magazine%20style%2C%20soft%20paper%20texture%2C%20cinematic%20wide%20banner&width=1800&height=900&seq=chigua-hero-01&orientation=landscape"
          alt="吃瓜百科合集导航插画背景"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/85 via-background-50/70 to-background-50"></div>
      </div>

      <div className="mx-auto flex w-full flex-col items-center px-4 py-16 md:py-24 text-center">
        <a
          href="#trending"
          className="mb-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-accent-500/15 border border-accent-300 px-4 py-1.5 text-xs font-medium text-accent-800"
        >
          <span className="flex h-2 w-2 rounded-full bg-accent-500 animate-pulse"></span>
          每日更新 · 今日已有 26 个新瓜入库
          <i className="ri-arrow-right-line text-sm"></i>
        </a>

        <h1 className="font-display text-4xl md:text-6xl font-black text-foreground-950 leading-tight">
          一站式吃瓜，
          <br className="md:hidden" />
          <span className="text-primary-600">情报在线</span>
        </h1>
        <p className="mt-6 max-w-2xl text-base md:text-lg text-foreground-600 leading-relaxed">
          吃瓜百科把全网热门人物、事件与领域，按知识图谱整理成一份清晰合集导航。
          不管你想追连续剧式长瓜，还是按兴趣直奔主题，从这里都能快速定位、随时补课。
        </p>

        <form
          className="mt-9 flex w-full max-w-xl flex-col sm:flex-row items-stretch gap-2 sm:rounded-full sm:border sm:border-background-300 sm:bg-background-50/95 sm:p-1.5 sm:shadow-sm"
          onSubmit={(e) => {
            e.preventDefault();
            const q = (e.currentTarget.querySelector("input")?.value || "").trim();
            document.getElementById("trending")?.scrollIntoView({ behavior: "smooth" });
            if (q) {
              window.dispatchEvent(new CustomEvent("chigua-search", { detail: q }));
            }
          }}
        >
          <label className="sr-only" htmlFor="hero-search">搜索吃瓜百科内容</label>
          <input
            id="hero-search"
            type="search"
            placeholder="搜索事件、人物或领域，例如：年度盘点…"
            className="w-full rounded-full border border-background-300 bg-background-50/95 px-5 py-3 text-sm text-foreground-900 outline-none placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-200 sm:border-0 sm:bg-transparent"
          />
          <button
            type="submit"
            className="whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors"
          >
            <i className="ri-search-line mr-1.5"></i>开始搜索
          </button>
        </form>

        <div className="mt-7 flex flex-wrap items-center justify-center gap-2">
          <span className="text-xs text-foreground-500 mr-1 whitespace-nowrap">热门标签：</span>
          {hotTags.slice(0, 5).map((t) => (
            <a
              key={t}
              href="#trending"
              className="whitespace-nowrap rounded-full border border-background-300 bg-background-50/80 px-3.5 py-1 text-xs text-foreground-700 hover:border-primary-300 hover:text-primary-700 transition-colors"
            >
              #{t}
            </a>
          ))}
        </div>
      </div>

      <div className="mx-auto w-full max-w-5xl px-4 md:px-6 pb-16">
        <dl className="grid grid-cols-2 gap-3 sm:grid-cols-4 md:gap-4">
          {stats.map((s) => (
            <div
              key={s.label}
              className="rounded-xl border border-background-200 bg-background-50/90 px-4 py-5 text-center"
            >
              <dt className="order-2 mt-1 block text-xs text-foreground-500">{s.label}</dt>
              <dd className="font-display text-2xl md:text-3xl font-bold text-primary-600">
                {s.num}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}